module.exports = __webpack_public_path__ + "media/src/assets/img/portrait/small/avatar-s-16-14093ce92facf62dd7ae31123483b4f6.jpg";